import React from 'react';
import { Field } from 'redux-form';
import Typography from '@material-ui/core/Typography';

import Fields from 'components/Fields';
import { wizardStyles } from 'components/Forms/Wizard/wizardUtils';
import { useFormatMessage } from 'components/IntlProvider';

interface GoalType {
  id: number;
  value: string;
  label: string;
}

interface ResearchGoalProps {
  goals: GoalType[];
}

const ResearchGoal = ({ goals }: ResearchGoalProps) => {
  const classes = wizardStyles();
  const t = useFormatMessage();

  return (
    <>
      <Typography
        component="h2"
        variant="subtitle1"
        color="inherit"
        className={classes.subtitle}
      >
        {t(
          'fields.wizard.researchgoal',
          'Which of the following statements regarding the product test are you most likely to agree with?'
        )}
      </Typography>
      <Field
        fullWidth
        component={Fields.RadioGroup}
        options={goals}
        name="research_goal"
      />
    </>
  );
};

export default ResearchGoal;
